module.exports = __webpack_public_path__ + "static/dietetyka-image-1-9df35ac0bb8f7b41c030e50d155979fb.png";